// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tiles":"tiles-IEj2V","tile":"tile-3ABNo","short":"short-g1qTn","bg":"bg-X1pKo","bottom":"bottom-jTNbd","full":"full-WDiwx","caption":"caption-38oCE"};